import { Grid } from "@material-ui/core";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import banner from "../images/banner.jpg";
import * as data from '../Data'
import { getCookie } from 'typescript-cookie'
import { Link } from "react-router-dom";
import { Member } from "../interfaces/Member";
import { useEffect, useState } from "react";
import image1 from '../images/image_1.jpg';
import image2 from '../images/image_2.jpg';
import image3 from '../images/image_3.jpg';

export function ShareTheLove() {
    const [owner, setOwner] = useState<Member>();

    useEffect(() => {
        const ownerCookie = getCookie('owner') || undefined;

        if (ownerCookie) {
            setOwner(JSON.parse(ownerCookie) as Member);
        } else {
            window.location.href = "/login";
        }
    }, [])

    return (
        <div>

            {owner && <Header owner={owner} />}

            {owner &&
                <div>
                    <Grid container>
                        <Grid item xs={12}>
                            <div style={{ width: '100%', margin: '0px' }}>
                                <img src={banner} style={{ width: '100%' }} alt='beach image' />
                            </div>
                            <div style={{
                                fontSize: '2.5em',
                                fontFamily: 'Assistant',
                                fontWeight: 'bold',
                                width: '100%',
                                textAlign: 'center',
                                margin: '10px'
                            }}>
                                Share the Love
                            </div>
                        </Grid>
                    </Grid>

                    <Grid container style={{ marginBottom: '60px' }}>
                        <Grid item xs={12}>
                            <div style={{
                                margin: 'auto',
                                width: '50%',
                                lineHeight: '130%',
                                fontSize: '1.15em',
                            }}>
                                <div style={{ marginTop: '20px' }}>
                                    With Epic Experiences, you can invite family and friends to enjoy your exclusive travel savings,
                                    too. That means special pricing on hotels, resorts, car rentals, and activities—so they can book
                                    smarter and travel more,too.
                                </div>
                                <div style={{ marginTop: '20px', textAlign: 'center' }}><b>Sharing is Simple</b></div>
                                <div style={{ marginTop: '20px' }}>
                                    Log in to Epic Experiences, head to Epic Travel Savings, and send an invitation. Once they
                                    accept, they’ll get quick instructions to create a FREE one-year account and start unlocking
                                    savings right away.
                                </div>
                                <div style={{ marginTop: '20px', textAlign: 'center' }}><b>Earn Reward Credits</b></div>
                                <div style={{ marginTop: '20px' }}>
                                    Here’s the fun part, when your family and friends book, you earn Rewards Credits from their
                                    reservations. They get access to great pricing, and you get rewarded for sharing it.
                                </div>
                                <div style={{ marginTop: '20px', textAlign: 'center' }}><b>Refer Family &amp; Friends</b></div>
                                <div style={{ marginTop: '20px' }}>If someone you invited is ready for more, connect them with an Epic Vacations representative to
                                    explore their own membership options. Be sure to ask about the rewards you can earn for
                                    successful referrals.
                                </div>
                                <div style={{ marginTop: '20px' }}>Share the love. Share the savings. Get rewarded.</div>
                            </div>
                        </Grid>
                    </Grid>
                </div>
            }

            {owner && <Footer />}
        </div>
    )
}